import { jsx as _jsx } from "react/jsx-runtime";
import "../react-table-config";
import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
const useStyles = makeStyles(theme => ({
    checked: {},
    root: {
        width: "100%",
        "&$checked": {
            color: theme.palette.secondary.contrastText
        }
    },
    colorSecondary: {
        color: theme.palette.secondary.contrastText
    },
    checkboxContainer: {
        width: "100%",
        textAlign: "center"
    }
}));
export function useSelectionColumn(hooks) {
    hooks.visibleColumns.push(columns => [
        // Let's make a column for selection
        {
            id: "selection",
            disableGroupBy: true,
            disableSortBy: true,
            disableFilters: true,
            disableGlobalFilter: true,
            disableResizing: true,
            disableEditing: true,
            Header,
            Cell
        },
        ...columns
    ]);
}
// The header can use the table's getToggleAllRowsSelectedProps method
// to render a checkbox
function Header({ getToggleAllRowsSelectedProps, onSelect, globalFilteredRowsById }) {
    const classes = useStyles();
    const selectProps = getToggleAllRowsSelectedProps();
    return (_jsx("div", { className: classes.checkboxContainer, children: _jsx(Checkbox, { classes: {
                root: classes.root,
                checked: classes.checked,
                colorSecondary: classes.colorSecondary
            }, ...selectProps, onChange: (e, checked) => {
                selectProps.onChange?.(e);
                onSelect(null, !selectProps.checked, globalFilteredRowsById);
            } }) }));
}
// The cell can use the individual row's getToggleRowSelectedProps method
// to the render a checkbox
function Cell({ row, isEditing, onSelect }) {
    const classes = useStyles();
    return (_jsx("div", { className: classes.checkboxContainer, children: _jsx(Checkbox, { ...row.getToggleRowSelectedProps(), disabled: isEditing, onChange: () => {
                row.toggleRowSelected();
                onSelect(row.index, !row.isSelected);
            } }) }));
}
//# sourceMappingURL=useSelectionColumn.js.map